import type { JSX } from 'react';

import type { ErrorHandlerProps } from 'src/app/pages/legal/policy/pageContext';

export function PolicyErrorHandler({ context: { error } }: ErrorHandlerProps): JSX.Element {
	throw new Error(`Failed to retrieve data for Policy page (error: ${error})`);
}
